import { LocaleEnum } from '@systemeio/ui'

export const getGoCardlessHelpPageLink = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.DUTCH: {
      return 'https://help-nl.systeme.io/article/2269-hoe-je-gocardless-integreert-met-systeme-io'
    }
    case LocaleEnum.DEUTSCH: {
      return 'https://help-de.systeme.io/article/2163-so-integrieren-sie-gocardless-mit-systemeio'
    }
    case LocaleEnum.FRENCH: {
      return 'https://aide.systeme.io/article/2140-comment-integrer-gocardless-a-systeme-io'
    }
    case LocaleEnum.JAPANESE: {
      return 'https://help-jp.systeme.io/article/2320-how-to-integrate-gocardless-with-systeme-io'
    }
    case LocaleEnum.PORTUGUESE: {
      return 'https://help-pt.systeme.io/article/2154-como-integrar-a-gocardless-a-systeme-io'
    }
    case LocaleEnum.SPANISH: {
      return 'https://help-es.systeme.io/article/2156-como-integrar-gocardless-con-systeme-io'
    }
    case LocaleEnum.ITALIAN: {
      return 'https://help-it.systeme.io/article/2161-come-integrare-gocardless-con-systeme-io'
    }
    default: {
      return 'https://help.systeme.io/article/2146-how-to-integrate-gocardless-with-systeme-io'
    }
  }
}
